import { formatDate, formatAmount } from '@/util/helpers'
import orderStatuses from '@/util/orderStatuses'
import classStatuses from '@/util/classStatuses'

export default function () {
  return {
    formatDate,
    formatAmount,
    orderStatuses,
    classStatuses,
    order: {},
  }
}
